type Props = {
  url: string
}

const PDFViewer: React.FC<Props> = ({ url }) => {
  return <iframe className="w-full aspect-square" src={url} title={'Angebot'}></iframe>
}

export default PDFViewer
